export const LOCATION_TYPES = {
    CASA_PRINCIPAL: 'CASA_PRINCIPAL',
    CASA_SECUNDARIA: 'CASA_SECUNDARIA',
    TRABAJO: 'TRABAJO',
    OTRO: 'OTRO',
};

export const LOCATION_TYPE_LABELS = {
    [LOCATION_TYPES.CASA_PRINCIPAL]: 'Casa principal',
    [LOCATION_TYPES.CASA_SECUNDARIA]: 'Casa secundaria',
    [LOCATION_TYPES.TRABAJO]: 'Trabajo',
    [LOCATION_TYPES.OTRO]: 'Otro',
};

export const LOCATION_TYPE_ICONS = {
    [LOCATION_TYPES.CASA_PRINCIPAL]: 'HomeIcon',
    [LOCATION_TYPES.CASA_SECUNDARIA]: 'HomeIcon',
    [LOCATION_TYPES.TRABAJO]: 'WorkIcon',
    [LOCATION_TYPES.OTRO]: 'PlaceIcon',
};

export const LOCATION_TYPE_OPTIONS = Object.entries(LOCATION_TYPE_LABELS).map(
    ([value, label]) => ({ value, label })
);